const cazhboxId = {
	cazhbox: {
		title: "Cazhbox",
		subtitle: "Ringkasan data Cazhbox",
		tabs: {
			cazhbox: "Cazhbox",
			transaction: "Transaksi",
		},
		list: {
			title: "Data Cazhbox",
			empty_state: {
				title: "Tidak ada data cazhbox",
				description: "Silakan tambahkan cazhbox baru.",
			},
			summary: {
				partner: "Cazhbox Partner",
				total_all_stores: "Total Cazhbox Semua Toko",
			},
			columns: {
				store: "Toko",
				level: "Level",
				account_no: "Nomor Akun",
				limit: "Limit",
				balance: "Saldo",
			},
		},
		transaction: {
			title: "Data Transaksi",
			empty_state: {
				title: "Tidak ada data transaksi",
				description: "Belum ada transaksi pada periode ini.",
			},
			filters: {
				account: "Akun",
				all_accounts: "Semua Akun",
				partner_tag: "(Partner)",
				store_tag: "(Toko)",
				type: "Jenis Transaksi",
				all_types: "Semua Transaksi",
				transfer: "Transfer",
				topup: "Topup",
				redeem: "Redeem",
			},
			columns: {
				date: "Tanggal",
				ref_id: "Ref ID",
				type: "Jenis Transaksi",
				account: "Akun",
				description: "Deskripsi",
				opening_balance: "Saldo Awal",
				amount: "Jumlah",
				closing_balance: "Saldo Akhir",
				status: "Status",
			},
			status: {
				success: "Sukses",
				failed: "Gagal",
			},
		},
		topup_modal: {
			trigger: "Isi Saldo",
			title: "Isi Saldo Cazhbox Partner",
			instruction: "Silahkan melakukan transfer ke Rekening Bank berikut:",
			bank_label: "Bank",
			virtual_account_suffix: "(Virtual Account)",
			account_name: "Nama Rekening",
			account_no: "Nomor Rekening",
			how_to: "Cara Isi Saldo",
		},
		withdraw_modal: {
			trigger: "Tarik Saldo",
			title: "Tarik Saldo Cazhbox Partner",
			instruction: "Silahkan melakukan transfer ke Rekening Bank berikut:",
			select_placeholder: "Pilih Bank",
			notes: {
				settlement:
					"Beberapa Bank butuh waktu proses settlement antara 2 - 3 hari kerja sampai saldo dibukukan ke rekening anda.",
				after_hours:
					"Transaksi di atas 100 juta yang dilakukan setelah jam 14:00 pada hari kerja akan diproses pada hari kerja berikutnya.",
				holiday:
					"Transaksi di atas 100 juta yang dilakukan pada hari libur akan diproses pada hari kerja.",
				banking_hours: "Ketentuan ini mengikuti jam operasional perbankan.",
			},
			cancel: "Batal",
			ok: "OK",
		},
	},
};

export default cazhboxId;
